import React from 'react';

interface Props {
    message: string;
    onRetry?: () => void;
}

const ErrorBanner: React.FC<Props> = ({ message, onRetry }) => (
    <div className="flex items-center gap-3 px-4 py-3 text-sm text-semantic-text-danger bg-semantic-bg-danger-subtle rounded-lg">
        <span className="flex-1">{message}</span>
        {onRetry && (
            <button
                onClick={onRetry}
                className="px-3 py-1 text-xs font-medium rounded-md
                    border border-semantic-border-danger
                    text-semantic-text-danger hover:bg-semantic-bg-danger-subtle/80
                    transition-colors"
            >
                Retry
            </button>
        )}
    </div>
);

export default ErrorBanner;
